module.exports = __webpack_public_path__ + "img/ventas.bfff69fd.png";